var App = App || {};

App.TestimonialsBand = (function ($) {
    'use strict';

    function Init() {
        const testimonialsBand = $(".widget.widget-testimonials-band");

        if (testimonialsBand.length) {
            testimonialsBand.each(function () {
                App.Base.SwipeInit($(this));
            });
        }
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.TestimonialsBand.Init();
});